import { render, staticRenderFns } from "./CommunityGuidelines.vue?vue&type=template&id=228827ac&scoped=true&"
import script from "./CommunityGuidelines.vue?vue&type=script&lang=js&"
export * from "./CommunityGuidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228827ac",
  null
  
)

export default component.exports